<template>
    <div>
        <b-modal :id="modalId"
                 modal-class="modal-success"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head">
                    <div class="success_modal_image">
                        <img src="@/assets/icon/newversion/ic-success-new.svg" alt="">
                    </div>
                </div>
                <div class="modal-base-body">
                    <div id="success_title" class="modal-head-txt">{{title}}</div>
                    <div id="success_msg" class="modal-body-txt" v-html="message"></div>
                </div>
                <div class="modal-base-footer">
                    <div class="btn-wrapper" @click="clickOk()">
                        <div class="btn-txt">{{btnOk}}</div>      
                    </div>
                    <div class="btn-wrapper btn-cancel" @click="clickCancel()"> 
                        <div class="btn-txt">{{btnCancel}}</div>  
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Locale from "@/helper/locale/locale.js";
import Util from "@/helper/Utility.js";
/**
 * @property {SuccessModalController} controller (required) /components/Modal/Controller/AlertModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "SuccessModal",
    props: {
        // busModal: Object,
        theme: String,
        controller: Object,
        modalId: String,
    },
    data: function() {
        return {
            title: '',
            tag: '',
            message: '',
            btnOk: '',
            btnCancel: '',
            busModal: null,
            lbl: Locale.getLbl(),
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        clickCancel: function() {
            this.controller.sendCallbackCancel({ tag: this.tag });
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk({ tag: this.tag });
        },
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.btnCancel = config.btnCancel;
            this.tag = config.tag;

            if (Util.isEmptyStr(config.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }

            if (Util.isEmptyStr(config.btnCancel)) {
                this.btnCancel = this.lbl.default.cancel;
            }

            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        },
    },
}
</script>
<style lang="scss">
    @import "@/style/modal.scss";
    .modal-success {
        @extend %modal-base;

        .modal-dialog {
            max-width: 360px;
        }

        .modal-base-head {
            margin-bottom: 20px;

            .success_modal_image{
                position: relative;

                &::after {
                    content: '';
                    background-image: url('../../../assets/icon/newversion/bg-success-modal.png');
                    background-repeat: no-repeat;
                    background-size: contain;
                    background-position: top center;
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: -35px;                  
                    left: 0;
                    right: 0;
                }

                img {
                    margin-top: -70px;
                    width: 110px;
                    margin-left: auto;
                    margin-right: auto;
                    display: block;
                    position: relative;
                    z-index: 1;
                }
            }
        }

        .modal-base-body {

            #success_title {
                color: $green-00987F;
                font-size: 1.75rem;
                font-family: $semi_bold;
                margin-bottom: 20px;
            }

            #success_msg {
                color: $a-gray-575757;
                font-size: 1.5rem;
                font-family: $regular;
                line-height: normal;
            }
        }

        .modal-base-footer {
            margin-top: 16px;
            display: flex;
            flex-direction: column;
            gap: 10px;
        }
    }
</style>
